import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  IconBell, IconCalendarCheck, IconClock, IconSend,
} from '@tabler/icons-react';
import TopBar from '../../components/layout/TopBar';
import { EmptyState, ErrorState, Skeleton } from '../../components/common';
import notificationApi from '../../api/notification/notificationApi';
import useFetch from '../../hooks/useFetch';
import { PATHS, toPath } from '../../routes/paths';
import { formatShortDate, formatTime, todayKey } from '../../utils/date';

const ICONS = {
  reminder: IconClock,
  confirmed: IconCalendarCheck,
  request: IconSend,
};

const when = (iso) => {
  const [date, time] = iso.split('T');
  return date === todayKey() ? formatTime(time.slice(0, 5)) : formatShortDate(date);
};

export default function NotificationsPage() {
  const navigate = useNavigate();
  const { data, loading, error, reload, setData } = useFetch(() => notificationApi.list(), [], { initial: [] });
  const hasUnread = data.some((n) => !n.read);

  const open = (n) => {
    if (!n.read) {
      notificationApi.markRead(n.id);
      setData((list) => list.map((x) => (x.id === n.id ? { ...x, read: true } : x)));
    }
    if (n.appointmentId) navigate(toPath(PATHS.appointmentDetail, { id: n.appointmentId }));
  };

  const markAll = async () => {
    await notificationApi.markAllRead();
    setData((list) => list.map((x) => ({ ...x, read: true })));
  };

  return (
    <div className="page notifications">
      <TopBar
        title="Notifications"
        bordered
        actions={hasUnread && <button type="button" className="link u-text-sm" onClick={markAll}>Mark all read</button>}
      />
      <div className="page__body">
        {loading && !data.length && <Skeleton count={4} height={76} />}
        {error && <ErrorState error={error} onRetry={reload} />}
        {!loading && !error && !data.length && (
          <EmptyState icon={<IconBell size={26} />} title="You’re all caught up">
            Appointment updates and reminders will appear here.
          </EmptyState>
        )}
        {!!data.length && (
          <div className="list-card">
            {data.map((n) => {
              const Icon = ICONS[n.type] || IconBell;
              return (
                <button key={n.id} type="button" className={`list-row notif ${n.read ? '' : 'notif--unread'}`} onClick={() => open(n)}>
                  <span className="notif__icon"><Icon size={20} /></span>
                  <div className="list-row__body">
                    <p className="list-row__title">{n.title}</p>
                    <p className="list-row__sub">{n.body}</p>
                  </div>
                  <span className="notif__time">{when(n.createdAt)}</span>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
